/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description questionCommentQuestionIdUsingGet参数
 * @property `questionId` 问题ID
 * @property `[orderBy]` 排序方式, 0正序-最早优先 1倒序-最新优先
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsquestionCommentQuestionIdUsingGet {
  // pathParams
  /**
   * 问题ID
   */
  questionId: number;
  // queryParams
  /**
   * 排序方式, 0正序-最早优先 1倒序-最新优先
   */
  orderBy?: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * questionCommentVO
 */
export type ParamsBodyquestionCommentUsingPost = models.QuestionCommentVO;
/**
 * @description questionQuestionIdCollectUsingPost参数
 * @property `questionId` 问题ID
 * @property `type` true关注 false取消关注
 */
export interface ParamsquestionQuestionIdCollectUsingPost {
  // pathParams
  /**
   * 问题ID
   */
  questionId: number;
  // queryParams
  /**
   * true关注 false取消关注
   */
  type: boolean;
}
/**
 * @description questionQuestionIdEditUsingGet参数
 * @property `questionId` 问题ID
 * @property `status` 问题状态 DRAFT草稿 PUBLISHED_EDIT已发布
 */
export interface ParamsquestionQuestionIdEditUsingGet {
  // pathParams
  /**
   * 问题ID
   */
  questionId: number;
  // queryParams
  /**
   * 问题状态 DRAFT草稿 PUBLISHED_EDIT已发布
   */
  status: string;
}
/**
 * @description questionQuestionIdRevokeUsingPost参数
 * @property `questionId` 问题ID
 */
export interface ParamsquestionQuestionIdRevokeUsingPost {
  // pathParams
  /**
   * 问题ID
   */
  questionId: number;
}
/**
 * @description questionQuestionIdTitleUsingGet参数
 * @property `questionId` 问题ID
 */
export interface ParamsquestionQuestionIdTitleUsingGet {
  // pathParams
  /**
   * 问题ID
   */
  questionId: number;
}
/**
 * @description questionQuestionIdUsingDelete参数
 * @property `questionId` 问题ID
 * @property `type` 状态 DRAFT草稿 PUBLISHED_EDIT已发布
 */
export interface ParamsquestionQuestionIdUsingDelete {
  // pathParams
  /**
   * 问题ID
   */
  questionId: number;
  // queryParams
  /**
   * 状态 DRAFT草稿 PUBLISHED_EDIT已发布
   */
  type: string;
}
/**
 * @description questionQuestionIdUsingGet参数
 * @property `questionId` 问题ID
 */
export interface ParamsquestionQuestionIdUsingGet {
  // pathParams
  /**
   * 问题ID
   */
  questionId: number;
}
/**
 * questionDraftVO
 */
export type ParamsBodyquestionSaveUsingPost = models.QuestionEditInfo;
/**
 * @description questionUsingPost参数
 * @property `sendNotice` 是否发送消息到Kim群
 */
export interface ParamsquestionUsingPost {
  // queryParams
  /**
   * 是否发送消息到Kim群
   */
  sendNotice: boolean;
}
/**
 * question
 */
export type ParamsBodyquestionUsingPost = models.QuestionVO;
export class QuestionApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 获取评论
   * @param params ParamsquestionCommentQuestionIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListCommentInfo
   */
  public questionCommentQuestionIdUsingGet = (
    params: ParamsquestionCommentQuestionIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListCommentInfo> => {
    const path = '/api/question/comment/{questionId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('orderBy' in params) p.query.orderBy = params.orderBy;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.questionId, 'questionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 评论
   
   * @param data: ParamsBodyquestionCommentUsingPost// questionCommentVO
   * @param opt ajax config
   * @returns models.CommonResultCommentInfo
   */
  public questionCommentUsingPost = (
    data: ParamsBodyquestionCommentUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultCommentInfo> => {
    const path = '/api/question/comment';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.questionCommentVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 关注提问
   * @param params ParamsquestionQuestionIdCollectUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public questionQuestionIdCollectUsingPost = (
    params: ParamsquestionQuestionIdCollectUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/question/{questionId}/collect';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    ajax.check(params.questionId, 'questionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 从草稿箱进入编辑页面获取提问内容
   * @param params ParamsquestionQuestionIdEditUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultquestionVO
   */
  public questionQuestionIdEditUsingGet = (
    params: ParamsquestionQuestionIdEditUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultquestionVO> => {
    const path = '/api/question/{questionId}/edit';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('status' in params) p.query.status = params.status;
    ajax.check(params.status, 'status');
    ajax.check(params.questionId, 'questionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 将草稿回溯到最新发布的版本
   * @param params ParamsquestionQuestionIdRevokeUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResultQuestionEditInfo
   */
  public questionQuestionIdRevokeUsingPost = (
    params: ParamsquestionQuestionIdRevokeUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultQuestionEditInfo> => {
    const path = '/api/question/{questionId}/revoke';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.questionId, 'questionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看问题的标题
   * @param params ParamsquestionQuestionIdTitleUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultQuestionSimpleInfo
   */
  public questionQuestionIdTitleUsingGet = (
    params: ParamsquestionQuestionIdTitleUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultQuestionSimpleInfo> => {
    const path = '/api/question/{questionId}/title';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.questionId, 'questionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 删除提问
   * @param params ParamsquestionQuestionIdUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public questionQuestionIdUsingDelete = (
    params: ParamsquestionQuestionIdUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/question/{questionId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    ajax.check(params.questionId, 'questionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看已发布的提问
   * @param params ParamsquestionQuestionIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultQuestionInfo
   */
  public questionQuestionIdUsingGet = (
    params: ParamsquestionQuestionIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultQuestionInfo> => {
    const path = '/api/question/{questionId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.questionId, 'questionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 保存提问草稿
   
   * @param data: ParamsBodyquestionSaveUsingPost// questionDraftVO
   * @param opt ajax config
   * @returns models.CommonResultQuestionEditInfo
   */
  public questionSaveUsingPost = (
    data: ParamsBodyquestionSaveUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultQuestionEditInfo> => {
    const path = '/api/question/save';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.questionDraftVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 发布提问
   * @param params ParamsquestionUsingPost
   * @param data: ParamsBodyquestionUsingPost// question
   * @param opt ajax config
   * @returns models.CommonResultquestionVO
   */
  public questionUsingPost = (
    params: ParamsquestionUsingPost,
    data: ParamsBodyquestionUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultquestionVO> => {
    const path = '/api/question';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('sendNotice' in params) p.query.sendNotice = params.sendNotice;
    ajax.check(params.sendNotice, 'sendNotice');
    p.data = data;
    ajax.check(data, 'body.question');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new QuestionApi();
